import { useStore, mapState, mapGetters } from 'vuex';
import { defineComponent } from 'vue';
import { formatSize } from '@remote/utils/index';
import '@remote/assets/css/speed.scss';
const speedRange = [{
  percent: 0,
  min: 0,
  max: 60
}, {
  percent: 16,
  min: 60,
  max: 500
}, {
  percent: 32,
  min: 500,
  max: 1024
}, {
  percent: 48,
  min: 1024,
  max: 5 * 1024
}, {
  percent: 64,
  min: 5 * 1024,
  max: 50 * 1024
}, {
  percent: 84,
  min: 50 * 1024,
  max: 100 * 1024
}, {
  percent: 100,
  min: 100 * 1024,
  max: 150 * 1024
}];
export default defineComponent({
  name: 'Speed',
  setup: () => {
    const store = useStore();
    return {
      store
    };
  },
  data() {
    return {
      marks: {
        0: '60KB',
        16: '500KB',
        32: '1MB',
        48: '5MB',
        64: '50MB',
        80: '100MB',
        100: '全速'
      },
      dragNum: 0,
      isDrag: false,
      domRect: {
        width: 343,
        height: 16,
        left: 16,
        top: 10,
        x: 16,
        y: 0
      },
      beforeSpeedTxt: ''
    };
  },
  computed: {
    ...mapState(['all', 'user', 'currentSpped', 'curDeviceRunner']),
    ...mapGetters(['runnerConfig']),
    speedLimit() {
      return this.currentSpped || this.runnerConfig.speed_limit;
    },
    percent() {
      return Math.floor(this.dragNum / this.domRect.width * 100);
    },
    speed() {
      if (this.percent >= 95) return -1;
      const index = speedRange.findIndex(v => v.percent >= this.percent);
      const range = speedRange[index];
      const size = (range.max - range.min) / 16 * (this.percent + 16 - range.percent) + range.min;
      return size * 1024;
    },
    speedTxt() {
      if (this.percent >= 95) return '全速';
      return formatSize(this.speed) + '/s';
    }
  },
  watch: {
    'runnerConfig.speed_limit': {
      handler(val, oldVal) {
        console.log('runnerConfig.speed_limit changed', val, oldVal);
        this.calculate();
      },
      immediate: true
    }
  },
  components: {},
  mounted() {
    window.addEventListener('touchmove', this.handleDrag.bind(this), false);
    this.calculate();
  },
  beforeUnmount() {
    this.changeSpeed();
  },
  unmounted() {
    window.removeEventListener('touchmove', this.handleDrag);
  },
  methods: {
    calculate() {
      if (this.$refs.speedProgress) {
        const rect = this.$refs.speedProgress.getClientRects()[0];
        this.domRect = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height,
          x: rect.x,
          y: rect.y
        };
        const percent = this.speedLimit < 0 ? 96 : this.size2percent(this.speedLimit);
        this.dragNum = rect.width * percent / 100;
      }
      this.beforeSpeedTxt = this.speedTxt;
    },
    changeSpeed() {
      if ((this.speed > 0 || this.speed === -1) && this.speedTxt !== this.beforeSpeedTxt) {
        this.store.dispatch('config', {
          type: 'user#runner',
          id: this.curDeviceRunner.id,
          set_params: {
            set_device_config: JSON.stringify({
              speed_limit: this.speed
            })
          }
        });
        this.store.commit('update', {
          currentSpped: this.speed
        });
      }
      this.$stat({
        action: 'remote_device_supernatant_close',
        data: {
          default_value: this.speed
        }
      });
    },
    handleDrag(event) {
      if (!this.isDrag) return;
      let touch = Math.round(event.targetTouches[0].pageX);
      if (touch < 0) {
        this.dragNum = 8;
      } else if (touch > this.domRect.width) {
        this.dragNum = this.domRect.width - 10;
      } else {
        this.dragNum = touch - this.domRect.left;
      }
      this.dragNum < 0 ? this.dragNum = 0 : this.dragNum;
    },
    handleClick(event) {
      this.dragNum = event.pageX - this.domRect.left;
    },
    size2percent(size) {
      const speed = size / 1024;
      const index = speedRange.findIndex(v => v.max > speed);
      const range = speedRange[index];
      console.log(range);
      const percent = (speed - range.min) / ((range.max - range.min) / 16) + speedRange[index - 1].percent;
      return percent;
    }
  }
});